import React from 'react';
import { createPortal } from 'react-dom';

// This empties the container the portal is getting rendered into
// keeping similiar behavior to ReactDOM.render

const createRenderedPortal = (Component, domNode) => {
    class HOC extends React.Component {
        constructor(props) {
            super(props);
            while (domNode.firstChild) {
                domNode.removeChild(domNode.firstChild);
            }
        }

        render() { return Component; }
    }
    return createPortal(<HOC />, domNode);
};

export { createRenderedPortal };
